import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeConfigurationView.';

  public static readonly provideTaxName = `${Id.prefix}provideTaxName`;
  public static readonly provideNonNegativeTaxRate = `${Id.prefix}provideNonNegativeTaxRate`;
  public static readonly selectCurrency = `${Id.prefix}selectCurrency`;
  public static readonly selectQuoteType = `${Id.prefix}selectQuoteType`;
  public static readonly configurationSaved = `${Id.prefix}configurationSaved`;
  public static readonly configuration = `${Id.prefix}configuration`;
  public static readonly currency = `${Id.prefix}currency`;
  public static readonly financialDefaults = `${Id.prefix}financialDefaults`;
  public static readonly nonTaxableQuoteItem = `${Id.prefix}nonTaxableQuoteItem`;
  public static readonly allowNonTaxableQuoteItem = `${Id.prefix}allowNonTaxableQuoteItem`;
  public static readonly taxName = `${Id.prefix}taxName`;
  public static readonly taxRatePercent = `${Id.prefix}taxRatePercent`;
  public static readonly addTax = `${Id.prefix}addTax`;
}

export class LangFranchiseeConfigurationView {
  private constructor() {}

  public static provideTaxName(params: { position: number }): string {
    return interpolate(Id.provideTaxName, params);
  }
  public static provideNonNegativeTaxRate(params: { name: string }): string {
    return interpolate(Id.provideNonNegativeTaxRate, params);
  }
  public static selectCurrency(): string {
    return interpolate(Id.selectCurrency);
  }
  public static selectQuoteType(): string {
    return interpolate(Id.selectQuoteType);
  }
  public static configurationSaved(): string {
    return interpolate(Id.configurationSaved);
  }
  public static configuration(): string {
    return interpolate(Id.configuration);
  }
  public static currency(): string {
    return interpolate(Id.currency);
  }
  public static financialDefaults(): string {
    return interpolate(Id.financialDefaults);
  }
  public static nonTaxableQuoteItem(): string {
    return interpolate(Id.nonTaxableQuoteItem);
  }
  public static allowNonTaxableQuoteItem(): string {
    return interpolate(Id.allowNonTaxableQuoteItem);
  }
  public static taxName(): string {
    return interpolate(Id.taxName);
  }
  public static taxRatePercent(): string {
    return interpolate(Id.taxRatePercent);
  }
  public static addTax(): string {
    return interpolate(Id.addTax);
  }
}

export class FranchiseeConfigurationViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.provideTaxName,
      "Please enter a {{glossary 'tax'}} Name in position {{position}}",
      'Validation for tax name with position'
    );
    register.add(
      Id.provideNonNegativeTaxRate,
      'Please provide a non negative {{glossary \'tax\'}} Rate on "{{name}}"',
      'Validation for non-negative tax rate'
    );
    register.add(Id.selectCurrency, 'Please select a Currency', 'Validation for selecting currency');
    register.add(
      Id.selectQuoteType,
      "Please select a {{glossary 'quote'}} Type",
      'Validation for selecting quote type'
    );
    register.add(Id.configurationSaved, 'Configuration saved', 'Toast message for configuration saved');
    register.add(Id.configuration, 'Configuration', 'Section title for configuration');
    register.add(Id.currency, 'Currency', 'Label for currency');
    register.add(Id.financialDefaults, 'Financial Defaults', 'Section header for financial defaults');
    register.add(
      Id.nonTaxableQuoteItem,
      "Non-taxable {{glossary 'quote-item:plural'}}",
      'Section header for non-taxable quote items'
    );
    register.add(
      Id.allowNonTaxableQuoteItem,
      "Allow non-taxable {{glossary 'quote-item:plural'}}",
      'Switch label for allowing non-taxable quote items'
    );
    register.add(Id.taxName, "{{glossary 'tax'}} Name", 'Label for tax name');
    register.add(Id.taxRatePercent, "{{glossary 'tax'}} Rate %", 'Label for tax rate percent');
    register.add(Id.addTax, "Add {{glossary 'tax'}}", 'Button label for adding a tax');
  }
}
